var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article"},[_c('div',{staticClass:"article__body"},[_c('PageContentWrapper',{staticClass:"text-white",attrs:{"document":_vm.content}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }